/**
 * Created by mh on 2017/8/6.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { observer } from 'mobx-react';

import LogsTableRowComponent from './LogsTableRow';

@observer
class LogsTable extends React.Component {
    render() {
        const { logs } = this.props;

        return (
            <div className="table-responsive">
                <table className="table table-sm table-striped table-delivermedia">
                    <thead>
                        <tr>
                            <th>
                                <FormattedMessage id="Jobs.LogLevel" defaultMessage="Log Level" />
                            </th>
                            <th>
                                <FormattedMessage id="Jobs.LogTimestamp" defaultMessage="Timestamp" />
                            </th>
                            <th>
                                <FormattedMessage id="Jobs.LogName" defaultMessage="Name" />
                            </th>
                            <th>
                                <FormattedMessage id="Jobs.LogMessage" defaultMessage="Message" />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {logs ?
                            logs.map(log => <LogsTableRowComponent log={log} key={log.id} />)
                            :
                            <tr>
                                <td>
                                    <FormattedMessage id="Jobs.NoLogsFound" defaultMessage="No Logs Found" />
                                </td>
                            </tr>}
                    </tbody>
                </table>
            </div>);
    }
}

LogsTable.propTypes = {
    logs: PropTypes.object.isRequired,
};

export default injectIntl(LogsTable);
